import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

export const loginUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/login`, userData);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      const err = new Error(error.response.data.message);
      err.status = error.response.status;
      throw err;
    }
    if (error.request) throw new Error('Network error. Please check your connection.');
    throw new Error(error.message || 'Login failed');
  }
};

export const signupUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/signup`, userData);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      const err = new Error(error.response.data.message);
      err.status = error.response.status;
      throw err;
    }
    if (error.request) throw new Error('Network error. Please check your connection.');
    throw new Error(error.message || 'Signup failed');
  }
};

export const getMe = async () => {
  const token = getStoredToken();
  if (!token) throw new Error('Not authenticated');
  const response = await axios.get(`${BASE_URL}/api/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/forgot-password`, { email });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      const err = new Error(error.response.data.message);
      err.status = error.response.status;
      throw err;
    }
    throw new Error(error.message || 'Request failed');
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/reset-password`, data);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      const err = new Error(error.response.data.message);
      err.status = error.response.status;
      throw err;
    }
    throw new Error(error.message || 'Reset failed');
  }
};

/** Update current user profile. Use PUT /api/auth/me (no userId in URL). */
export const updateMe = async (profileData) => {
  const token = getStoredToken();
  if (!token) throw new Error('Not authenticated');
  try {
    const response = await axios.put(`${BASE_URL}/api/auth/me`, profileData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      const err = new Error(error.response.data.message);
      err.status = error.response.status;
      throw err;
    }
    throw new Error(error.message || 'Update failed');
  }
};
